module.exports = __webpack_public_path__ + "img/five4Blue.3b78004e.jpg";